import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index";
import { German } from "flatpickr/dist/l10n/de.js";
import * as sweetalert2 from "sweetalert2";
import Chart from "chart.js";
import $ from "jquery";
import tippy, {followCursor} from "tippy.js";

import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";

window.tippy = tippy;

window.runTippy = () => {
  if (window._tippyInstances) {
    window._tippyInstances.forEach(instance => instance.destroy());
  }

  window._tippyInstances = tippy('[filament-tippy-content]', {
    content(reference) {
      return reference.getAttribute('filament-tippy-content');
    },
    followCursor: true,
    theme: 'light',
    plugins: [followCursor],
  });

  return window._tippyInstances;
}

window.runTippy();

window.$ = $;
window.Chart = Chart;
window.swal = sweetalert2;
flatpickr.localize(German);
window.monthSelectPlugin = monthSelectPlugin;
window.flatpickr = flatpickr;

window.onlyNumbers = function (value, before, maxChars = 5) {
  let number = ("" + value).replace(/[\D]/g, "");
  if (number === null || number === "") {
    return 0;
  }
  if (number.length > maxChars) {
    return before;
  }

  return parseInt(number);
};

window.numberGermanToEng = function (number) {
  return parseFloat(('' + number).replace(',', '.'))
};
window.numberEngToGerman = function (number) {
  return number.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})
}
window.germanNumberToCent = function(number){
  return numberGermanToEng(number) * 100;
}

// window.monthSelectPlugin = monthSelectPlugin;

// import { livewire_hot_reload } from "virtual:livewire-hot-reload";
//
// livewire_hot_reload();
